// Copyright 2024 Sadiant Inc. All Rights Reserved. This software is subject to a license agreement. Unauthorized or unlicensed use is prohibited.
export function nameOf<T>(_o?: T) {
  return new Proxy(
    {},
    {
      get: (_target, prop, _receiver) => prop
    }
  ) as { [P in keyof Required<T>]: P };
}
